<template>
  <div class="footer">
    <div class="footer-container">
      <div class="logo-section">
        <img class="logo" alt="Logo" src="@/assets/logoYellow.svg" />
        <div class="access-permits">{{ $t('message.access_permit') }}</div>
      </div>
      <div class="contact-section">
        <div class="company-name">Port of Oulu Ltd.</div>
        <div class="address">
          <p>Poikkimaantie 16</p>
          <p>90400 Oulu</p>
          <p>Finland</p>
        </div>
        <div class="contact-wrapper">
          <div class="contact">
            <span>{{ $t('message.contact_the_gate') }}:</span>
          </div>
          <div class="phone">+358 44 703 2759</div>
        </div>
      </div>
      <div class="policy-section">
        <div class="policy-link">
          <a href="https://ouluport.com/saavutettavuusseloste/">{{
            $t('message.accessibility_statement')
          }}</a>
        </div>
        <div class="policy-link">
          <a href="https://ouluport.com/tietosuojaseloste/">{{ $t('message.privacy_policy') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TheFooter'
})
</script>

<style scoped>
.informationSection {
  width: 100%;
  position: relative;
  background-color: #f4f4f4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 64px 0px;
  box-sizing: border-box;
}

.footer {
  width: 100%;
  position: relative;
  background-color: var(--app-dark);
  color: #fff;
  font-family: Antarlida, sans-serif;
  text-align: left;
  display: flex;
  justify-content: center;
}

.footer-container {
  padding: 80px 80px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 32px;
}

.logo-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
}

.contact-wrapper {
  padding-top: 6px;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
}

.logo {
  width: 110px;
  height: 43px;
  object-fit: contain;
}

.access-permits {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: -0.36px;
  line-height: 110%;
  font-size: 18px;
}

.contact-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.company-name {
  font-weight: 600;
  font-style: normal;
  line-height: 110%;
  font-size: 16px;
}

.address p {
  margin: 0;
  font-style: normal;
  font-size: 15px;
  font-weight: 400;
  line-height: 150%;
}

.contact span {
  font-weight: 600;
}

.phone {
  font-weight: normal;
  line-height: 110%;
}

.policy-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.a {
  color: var(--app-white);
}
.policy-link {
  text-decoration: underline;
  font-weight: 600;
  line-height: 110%;
}
/* Mobile  */
@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    align-items: flex-start;
    padding: 40px 24px 48px;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 0px 0px;
  }

  .logo {
    width: 80px;
    height: 30px;
  }

  .access-permits,
  .company-name,
  .phone,
  .policy-link {
    font-size: 14px;
  }
}
@media (hover: hover) {
  a:hover {
    color: var(--app-yellow) !important;
  }
}
</style>
